/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartScatterCategoryAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-chart-scatter-category-alt_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-chart-scatter-category-alt_svg__st0"
      d="M16 8h2V6h2V4h-2V2h-2v2h-2v2h2zm-4-6H6v6h6V2zm-2 4H8V4h2v2z"
    />
    <path className="ico-chart-scatter-category-alt_svg__st0" d="M4 2H2v20h20v-2H4z" />
    <path
      className="ico-chart-scatter-category-alt_svg__st0"
      d="M8 16h2v-2h2v-2h-2v-2H8v2H6v2h2zm8-4v6h6v-6h-6zm4 4h-2v-2h2v2z"
    />
  </Icon>
);
export { SvgChartScatterCategoryAlt as ChartScatterCategoryAlt };
